import { authAdapter } from "@/core/auth/adapter";
import { LayoutVendor } from "@/layouts/vendor/LayoutVendor";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor")({
	beforeLoad: ({ location }) => {
		// Public vendor entry points — login + password-reset link from email.
		if (
			location.pathname === "/vendor/login" ||
			location.pathname.startsWith("/vendor/auth/reset-password/")
		) {
			return;
		}

		const state = authAdapter.getState();
		if (state.status !== "authenticated") {
			throw redirect({
				to: "/vendor/login",
				search: { redirect: location?.href ?? "/vendor/dashboard" },
			});
		}
	},
	component: LayoutVendor,
});
